'use client'

/**
 * CiteButton — copies a ready-made Fridge.com attribution string to the
 * clipboard (owner directive 07/20, Section E item 14: citation disclaimer +
 * "you must credit/cite Fridge.com"). The exact citation text is composed
 * server-side and passed in, so this is a thin copy affordance only.
 */
import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

export function CiteButton({ citation }: { citation: string }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(citation)
      setCopied(true)
      setTimeout(() => setCopied(false), 1800)
    } catch {
      /* clipboard unavailable — the citation is shown in full beside the button */
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      className="inline-flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white font-semibold text-[13px] px-4 py-2 rounded-full transition-colors shrink-0"
    >
      {copied ? <Check className="w-4 h-4 text-[#ff9951]" /> : <Copy className="w-4 h-4" />}
      {copied ? 'Copied' : 'Copy citation'}
    </button>
  )
}
